import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React from 'react';
import Slider, { Settings } from 'react-slick';
import { Link } from 'react-router-dom';
interface FooterBannerCarouselProps {
  data: {
    id: string;
    label: string;
    image: string;
    link: string;
  }[];
  bannerHeight: string | number;
  setCurrentIdx: (idx: number) => void;
  currentIdx: number;
}
const FooterBannerCarousel = ({ data, bannerHeight, setCurrentIdx, currentIdx }: FooterBannerCarouselProps) => {
  const settings: Settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    onInit: () => {
      window.dataLayer.push({
        event: 'init_ad',
        category: 'ad',
        action: 'impression',
        label: 'ad_impression_all',
      });
      window.dataLayer.push({
        event: 'view_ad',
        category: 'ad',
        action: 'impression',
        label: `ad_banner_${currentIdx + 1}`,
        event_id: data[currentIdx].id,
      });
    },
    afterChange: (index: number) => {
      setCurrentIdx(index);
      window.dataLayer.push({
        event: 'view_ad',
        category: 'ad',
        action: 'impression',
        label: `ad_banner_${index + 1}`,
        event_id: data[index].id,
      });
    },
    swipeEvent: (swipeDirection: string) => {
      // onSwipe 작동안하여 swipeEvent 사용
      // https://github.com/akiran/react-slick/issues/1952#issuecomment-2209221726
      window.dataLayer.push({
        event: 'swipe_ad',
        category: 'ad',
        action: `swipe_${swipeDirection}`,
        label: `ad_banner_${currentIdx + 1}`,
        event_id: data[currentIdx].id,
      });
    },
  };

  return (
    <Slider {...settings}>
      {data.map((item, index) => (
        <Link
          id={`btn_banner_${index + 1}`}
          key={item.label}
          to={item.link}
          data-id={`btn_banner_${index + 1}_${item.id}`}
        >
          <div
            style={{
              backgroundImage: `url(${item.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              width: '100%',
              height: bannerHeight,
            }}
            aria-label="banner"
          />
        </Link>
      ))}
    </Slider>
  );
};

export default FooterBannerCarousel;
